import {SSLogHeadersList} from "./SSLogHeadersList";
import {SSLogHeadersEdit} from "./SSLogHeadersEdit";
import {SSLogHeadersCreate} from "./SSLogHeadersCreate";

export default {
    list: SSLogHeadersList,
    edit: SSLogHeadersEdit
};
